<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'statuts',

    metaInfo: { title: 'Statuts' },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'statuts',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'statuts',
      },
    },
  }
</script>
